export const ERROR_PAGES_NS = 'pages/ErrorPages';

export const i18n = {
  en: {
    unknown: 'Unknown error occurred',
    timeout: 'Sorry, your session has expired.',
    hint: 'Please click Sign In below or refresh the browser window.',
    button: 'Sign In',
    goBack: 'Go back',
    pageNotFound: 'Page not found',
    pageDoesntExist: "The page doesn't exists or is unavailable. ",
    unexpectedEnvironment: 'Unexpected Environment',
  },
};
